import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import DatePicker from "~/common/components/DatePicker";
import Form, { Group } from "~/common/components/Form";
import { API_STATE } from "~/common/constants/state";
import useAlert from "~/common/hooks/useAlert";
import useRequest from "~/common/hooks/useRequest";
import { AppManContext } from "../../../RoundManContext";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import Processing from "~/pages/investment/InvestSettingPage/processingModal/Processing";

const ProTwoDate = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { addProSteps, setAddProSteps, resultFromProTwo, setresultFromProTwo } =
		useContext(AppManContext);

	const currentDate = new Date();
	const nextDay = new Date(
		currentDate.getFullYear(),
		currentDate.getMonth(),
		currentDate.getDate() + 1,
		23,
		59,
		59
	);

	const defaultValue = {
		defaultValues: {
			startDate: resultFromProTwo.startDate ?? new Date(),
			endDate: resultFromProTwo.endDate ? new Date(resultFromProTwo.endDate) : nextDay,
		},
	};

	const addJudgeDateForm = useForm(defaultValue);

	const roundDetailRequest = useRequest("get", "/vc/round/setting/detail");
	const [showCompanySelectAlert, SettingSelectPlz] = useAlert();
	const [showErrorAlert, ErrorAlert] = useAlert();

	const startDate = addJudgeDateForm.watch("startDate");
	const endDate = addJudgeDateForm.watch("endDate");


	const [roundItemModal, setRoundItemModal] = useState(false);

	//----심사항목 삭제 Alert 모달 ----------------------------------------------------
	const [deleteAlertModal, setDeleteAlertModal] = useState(false);
	const [noCategoryAlert, setNoCategoryAlert] = useState(false);
	const [weightingAlert, setWeightingAlert] = useState(false);
	const [noEvaluationAlert, setNoEvaluationAlert] = useState(false);
	const [noTitleAlert, setNoTitleAlert] = useState(false);
	const [noCategoryName, setNoCategoryName] = useState(false);
	const [noItemName, setNoItemName] = useState(false);
	const [settingList, setSettingList] = useState([]);
	const [settingDetail, setSettingDetail] = useState({});
	const [evalCategories, setEvalCategories] = useState([]);
	const [step, setStap] = useState("");
	const settingListRequest = useRequest("get", "/vc/invest/setting/list");
	const settingCreateRequest = useRequest("post", "/vc/invest/setting/add");
	const settingModifyRequest = useRequest("post", "/vc/invest/setting/edit");

	const [resetItemData, setResetData] = useState("");
	const [targetIdx, setTargetIdx] = useState("");
	const [createNew, setCreateNew] = useState("create");
	const [isSelect, setIsSelect] = useState(false)

	useEffect(() => {
		settingListRequest.call();
	}, []);

	useEffect(() => {
		switch (settingListRequest.state) {
			case API_STATE.done:
				const resData = settingListRequest.response?.data.list;
				setSettingList(resData);
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [settingListRequest.state, settingListRequest.response, settingListRequest.error]);


	const moveToNextStep = () => {
		if (resultFromProTwo === "nope") {
			showCompanySelectAlert();
			return;
		}
		setresultFromProTwo({ ...resultFromProTwo, startDate: startDate, endDate: endDate });
		setAddProSteps(addProSteps + 1);
	};

	const moveToPrevStep = () => {
		setAddProSteps(addProSteps - 1);
	};

	const handleEvalSelect = (e) => {
		let detailIdx = e.target.value;
		if (detailIdx === 0 || detailIdx === "0") {
			setresultFromProTwo("nope");
		} else {
			roundDetailRequest.call(detailIdx, "path");
		}
	};

	useEffect(() => {
		settingListRequest.call();
	}, []);

	const handleNewCreation = (createFormData) => {
		settingCreateRequest.call(createFormData);
	};

	const handleModify = (modiFormData) => {
		settingModifyRequest.call(modiFormData);
	};

	useEffect(() => {
		switch (roundDetailRequest.state) {
			case API_STATE.done:
				setresultFromProTwo({ settingData: roundDetailRequest.response.data });
				break;
			case API_STATE.error:
				console.log("얼마나 작동 error>> ", roundDetailRequest.error);
				alert(t("pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.alert"));
				break;
			default:
				break;
		}
	}, [roundDetailRequest.state, roundDetailRequest.response, roundDetailRequest.error]);

	useEffect(() => {
		switch (settingCreateRequest.state) {
			case API_STATE.done:
				// let res = settingCreateRequest.response;
				// setSelectValue({
				// 	label: res.title, value: res.idx
				// })
				setRoundItemModal(false);
				settingListRequest.call();
				setIsSelect(true)
				break;
			case API_STATE.error:
				console.log("settingCreateRequest error !!! >> ", settingCreateRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingCreateRequest.state, settingCreateRequest.response, settingCreateRequest.error]);

	useEffect(() => {
		if (isSelect && settingList.length > 0) {
			const lastItem = settingList[settingList.length - 1];
			setresultFromProTwo(prev => ({
				...prev,
				settingData: { ...prev.settingData, idx: lastItem.idx }
			}));
		}
	}, [settingList, isSelect]);

	return (
		<>
			<div className="modal-content addCriteriaSetup">
				<div className="side-content">
					<h3>
						{t(
							"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.sideContent"
						)}
					</h3>
				</div>
				<section className="c__card">
					<div className="period-setting">
						<div className="title">
							{t(
								"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.period.title"
							)}
						</div>
						<Form useForm={addJudgeDateForm}>
							<Group className="datePicker-group">
								<DatePicker
									name={"startDate"}
									maxDate={endDate}
									onChange={(date) => {
										if (date.getDate() === new Date().getDate()) {
											addJudgeDateForm.setValue("startDate", new Date());
										} else {
											addJudgeDateForm.setValue(
												"startDate",
												new Date(
													date.getFullYear(),
													date.getMonth(),
													date.getDate(),
													0,
													0,
													0
												)
											);
										}
									}}
								/>
								<span className="dash"> - </span>
								<DatePicker name={"endDate"} minDate={startDate} />
							</Group>
						</Form>
						{/*<div className="setting-order">*/}
						{/*	<p className="setting-notice">*/}
						{/*		{t(*/}
						{/*			"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.period.settingNotice"*/}
						{/*		)}*/}
						{/*	</p>*/}
						{/*</div>*/}
					</div>
					<div>
						<div className="title">
							{t(
								"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.item.title"
							)}
						</div>
						<select
							className="c__select"
							onChange={handleEvalSelect}
							value={resultFromProTwo?.settingData?.idx}
						>
							{settingList && (
								<option value={0}>
									{t(
										"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.item.selectDefault01"
									)}
								</option>
							)}
							{settingList ? (
								settingList.map((d, idx) => (
									<option value={d.idx} key={idx + 1}>
										{d.title}
									</option>
								))
							) : (
								<option value={0}>
									{t(
										"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.item.selectDefault02"
									)}
								</option>
							)}
						</select>
						<div className="setting-order">
							<p className="setting-notice">
								{t(
									"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.item.settingNotice"
								)}
								<button
									type="button"
									className="btn-link"
									onClick={() => setRoundItemModal(true)}
								>
									{t(
										"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.item.button"
									)}
								</button>
							</p>
						</div>
					</div>
				</section>
			</div>
			<div className="modal-footer">
				<button type="button" className="btn__solid" color="gray" onClick={moveToPrevStep}>
					{t("pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.prev")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={moveToNextStep}
				// onClick={showJudgeDateAlert}
				// onClick={showConfirmAlert}
				// onClick={showExternalAlert}
				>
					{t("pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.next")}
				</button>
				{/*<button*/}
				{/*	type="button"*/}
				{/*	className="btn__solid"*/}
				{/*	color="primary"*/}
				{/*	onClick={() => setEvaluateSetupModal(false)}*/}
				{/*>*/}
				{/*	확인*/}
				{/*</button>*/}
			</div>

			<SettingSelectPlz
				type="warning"
				message={t(
					"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.selectWarning"
				)}
				confirm={t(
					"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.confirm"
				)}
			/>
			<Processing
				{...{
					settingDetail,
					setSettingDetail,
					createNew,
					roundItemModal,
					setRoundItemModal,
					setNoCategoryAlert,
					setWeightingAlert,
					setNoEvaluationAlert,
					setNoTitleAlert,
					resetItemData,
					setResetData,
					setNoCategoryName,
					setNoItemName,
					handleModify,
					handleNewCreation,
					targetIdx,
				}}
			/>
			<ErrorAlert
				message={t(
					"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.errorWarningTitle"
				)}
				subMessage={t(
					"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.errorWarningSub"
				)}
				type="warning"
				confirm={t(
					"pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.confirm"
				)}
				reject={t("pages.round.RoundManage.modal.additionalRound.steps.ProTwoDate.reject")}
			/>
		</>
	);
};

export default ProTwoDate;
